import {
  formatDateParam,
  makeRequest,
  constructUrlParamsByRange,
  constructUrlParamsBySpecificDate,
} from "../lib/makeRequest";

export const profit_breakdown_overall_v4 = (data) => {
  const urlParams = data.isRange
    ? constructUrlParamsByRange(
        formatDateParam(data.dates.from),
        formatDateParam(data.dates.to)
      )
    : constructUrlParamsBySpecificDate(formatDateParam(data.covered_date));
  return makeRequest(`/profit-breakdowns/overall?${urlParams.toString()}`);
};

export const profit_breakdown_cluster_v4 = (data) => {
  const urlParams = data.isRange
    ? constructUrlParamsByRange(
        formatDateParam(data.dates.from),
        formatDateParam(data.dates.to)
      )
    : constructUrlParamsBySpecificDate(formatDateParam(data.covered_date));

  return makeRequest(
    `/profit-breakdowns/cluster/${data.clusterId}?${urlParams.toString()}`
  );
};

export const profit_breakdown_area_v4 = (data) => {
  const params = data.isRange
    ? {
        from: formatDateParam(data.dates.from),
        to: formatDateParam(data.dates.to),
      }
    : {
        coveredDate: formatDateParam(data.covered_date),
      };

  return makeRequest(`/profit-breakdowns/area/${data.area_code}`, params);
};

export const profit_breakdown_branch_v4 = (data) => {
  console.log("profit_breakdown_branch_v4", data);

  const urlParams = data.isRange
    ? constructUrlParamsByRange(
        formatDateParam(data.dates.from),
        formatDateParam(data.dates.to)
      )
    : constructUrlParamsBySpecificDate(formatDateParam(data.covered_date));

  return makeRequest(
    `/profit-breakdowns/branches?${urlParams.toString()}`,
    data.branch_codes,
    "post"
  );
};
